import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=520c3c73&scoped=true"
import script from "./upload.vue?vue&type=script&lang=ts"
export * from "./upload.vue?vue&type=script&lang=ts"
import style0 from "./upload.vue?vue&type=style&index=0&id=520c3c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c3c73",
  null
  
)

export default component.exports